import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Dashboard.scss';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="dashboard">
      <div className="container">
        <div className="dashboard__content">
          <header className="dashboard__header">
            <h1 className="dashboard__title">
              Welcome back, <span className="gradient-text">{user?.first_name}</span>!
            </h1>
            <p className="dashboard__subtitle">
              Here's your CoinVAT trading dashboard
            </p>
          </header>

          <div className="dashboard__stats">
            <div className="dashboard__stat-card">
              <h3>Portfolio Value</h3>
              <p className="dashboard__stat-value">$0.00</p>
              <span className="dashboard__stat-change">+0.00%</span>
            </div>
            
            <div className="dashboard__stat-card">
              <h3>Active Trades</h3>
              <p className="dashboard__stat-value">0</p>
              <span className="dashboard__stat-change">No active trades</span>
            </div>
            
            <div className="dashboard__stat-card">
              <h3>24h P&L</h3>
              <p className="dashboard__stat-value">$0.00</p>
              <span className="dashboard__stat-change">+0.00%</span>
            </div>
          </div>

          <div className="dashboard__actions">
            <button className="btn btn-primary">
              Start Trading
            </button>
            <button className="btn btn-secondary">
              Connect Exchange
            </button>
            <button className="btn btn-outline">
              Connect Wallet
            </button>
          </div>

          <div className="dashboard__info">
            <h2>Get Started</h2>
            <p>
              To begin trading, you'll need to connect an exchange account or Web3 wallet.
              Our AI-powered trading strategies will help maximize your portfolio performance.
            </p>
          </div>

          <div className="dashboard__user-info">
            <h3>Account Information</h3>
            <div className="dashboard__user-details">
              <p><strong>Email:</strong> {user?.email}</p>
              <p><strong>Name:</strong> {user?.first_name} {user?.last_name}</p>
              <p><strong>Account Status:</strong> {user?.is_verified ? 'Verified' : 'Unverified'}</p>
              <p><strong>Member Since:</strong> {user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;